import { Session } from 'types';
import Pagination from 'sources/sourceTypes/Pagination';

import { SessionActions } from 'types/store/actions/sessions';
import { SessionActionTypes } from 'types/store/actions/constants';

export const listSuccess = (payload: Pagination<Session>): SessionActions => ({
  type: SessionActionTypes.LIST_SUCCESS,
  payload,
});

export const fetchSuccess = (record: Session): SessionActions => ({
  type: SessionActionTypes.FETCH_SUCCESS,
  payload: record,
});

export const reset = (): SessionActions => ({
  type: SessionActionTypes.RESET,
});

export const setLoading = (isLoading: boolean): SessionActions => ({
  type: SessionActionTypes.SET_LOADING,
  payload: { isLoading },
});
